import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import './types';

import commonZh from './locales/zh-CN/common.json';
import authZh from './locales/zh-CN/auth.json';
import tasksZh from './locales/zh-CN/tasks.json';
import reviewZh from './locales/zh-CN/review.json';
import sessionsZh from './locales/zh-CN/sessions.json';
import navigationZh from './locales/zh-CN/navigation.json';

import commonEn from './locales/en/common.json';
import authEn from './locales/en/auth.json';
import tasksEn from './locales/en/tasks.json';
import reviewEn from './locales/en/review.json';
import sessionsEn from './locales/en/sessions.json';
import navigationEn from './locales/en/navigation.json';

const resources = {
  'zh-CN': {
    common: commonZh,
    auth: authZh,
    tasks: tasksZh,
    review: reviewZh,
    sessions: sessionsZh,
    navigation: navigationZh,
  },
  en: {
    common: commonEn,
    auth: authEn,
    tasks: tasksEn,
    review: reviewEn,
    sessions: sessionsEn,
    navigation: navigationEn,
  },
} as const;

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: 'zh-CN',
    fallbackLng: 'en',
    defaultNS: 'common',
    ns: ['common', 'auth', 'tasks', 'review', 'sessions', 'navigation'],
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'cookie'],
      lookupLocalStorage: 'i18nextLng',
      lookupCookie: 'i18next',
      caches: ['localStorage', 'cookie'],
    },
  });

export default i18n;
